/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Reply_PlaceholderInputs */

const en_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter reply...`)
};

const fr_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une reponse...`)
};

const de_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort eingeben...`)
};

const it_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la risposta...`)
};

const ru_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите ответ...`)
};

const es_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introducir respuesta...`)
};

const zh_cn2_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入回复内容……`)
};

const ja_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信を入力してください...`)
};

const hi_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तर दर्ज करें...`)
};

const pt_pt2_event_notes_reply_placeholder = /** @type {(inputs: Event_Notes_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite a resposta...`)
};

/**
* | output |
* | --- |
* | "Enter reply..." |
*
* @param {Event_Notes_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_reply_placeholder = /** @type {((inputs?: Event_Notes_Reply_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Reply_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_notes_reply_placeholder(inputs)
	if (locale === "de") return de_event_notes_reply_placeholder(inputs)
	if (locale === "it") return it_event_notes_reply_placeholder(inputs)
	if (locale === "ru") return ru_event_notes_reply_placeholder(inputs)
	if (locale === "es") return es_event_notes_reply_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_event_notes_reply_placeholder(inputs)
	if (locale === "ja") return ja_event_notes_reply_placeholder(inputs)
	if (locale === "hi") return hi_event_notes_reply_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_event_notes_reply_placeholder(inputs)
	return en_event_notes_reply_placeholder(inputs)
});